import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EdAssistUIButtonModule } from '@edassist-ui/button';
import { EdAssistUIToggleLinkModule } from '@edassist-ui/toggle-link';
import { EdAssistUICollapsiblePanelModule } from '@edassist-ui/collapsible-panel';
import { OtherServicesMobileComponent } from './other-services-mobile.component';
import { EdAssistUIButtonLinkModule } from '@edassist-ui/button-link';

@NgModule({
	declarations: [OtherServicesMobileComponent],
	exports: [OtherServicesMobileComponent],
	imports: [
		CommonModule,
		EdAssistUIButtonModule,
		EdAssistUIButtonLinkModule,
		EdAssistUICollapsiblePanelModule,
		EdAssistUIToggleLinkModule
	]
})
class OtherServicesMobileModule {}
export { OtherServicesMobileComponent, OtherServicesMobileModule };
